export default {
  overview: '概览',
  today_overview: '今日概览',
  balance: '余额',
  in_transit: '在途',
  abd_balance: 'ADB金额',
  total_transaction: '总交易',
  transaction_count: '交易笔数',
  transaction_amount: '交易金额',
  transaction_fee: '交易费用',
  payin: '收款交易',
  payout: '付款交易',
  number: '笔数',
  amount: '金额',
  payin_number: '收款笔数',
  payout_number: '付款笔数',
  payin_amount: '收款金额',
  payout_amount: '付款金额',
  transaction_trends: '交易趋势',
  all: '全部',
  fee: '服务费',
  today: '今天',
  week: '过去7天',
  month: '过去30天',
  commission: '佣金'
}
